import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getcompanyLoginpage, getCompanys, loginUser, ResetUserPassWord, UpdateUserPassWord, VerifyUserOtp } from "../../services/dataService";
import toast from "react-hot-toast";
import Attukulalogo from "../../assets/images/human-resource-bg-left-min.png";
import auth_bg from "../../assets/images/attukal_bg.jpg";
import { getSecureItem, setSecureItem } from "../../services/SecureStorage";

export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [mobileError, setMobileError] = useState('');
  const [reset, setReset] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [otpLoading, setOtpLoading] = useState(false);
  const [successOtp, setSuccessOtp] = useState(false);

  // New password reset states
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    NewPassword: '',
    ConfirmPassword: ''
  });
  const [passwordError, setPasswordError] = useState('');
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);

  const [saveData, setSaveData] = useState({
    UserMobile: '',
  });

  const UID = getSecureItem("userId");
  const [companyDetails, setCompanyDetails] = useState([]);

  const fetchCompanyDetails = async () => {
    try {
      const response = await getcompanyLoginpage(UID);
      setCompanyDetails(response.data.data[0]);
      console.log(response.data.data[0], 'Response Data');
    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An error occurred while fetching company details');
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  const [formData, setFormData] = useState({
    UserName: "",
    Password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // New password toggle functions
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // New password change handler
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (passwordError) setPasswordError('');
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await loginUser(formData);
      setSecureItem("authToken", response.data.token);
      setSecureItem("userId", response.data.user.Id);
      setSecureItem("UserName", response.data.user.UserName);
      setSecureItem("DepartmentId", response.data.user.DepartmentId);
      setSecureItem("IsAdmin", response.data.user.IsAdmin);
      setSecureItem("UserType", response.data.user.UserType);

      if (response.data.message === "Login successful") {
        toast.success(response?.data?.message || "Login Successful");
        setLoading(false);
        navigate("/");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      toast.error("Invalid Credentials");
      setLoading(false);
    }
  };

  const handleClickForget = () => {
    setIsReset(true);
    // Reset states when entering forgot password mode
    setSaveData({ UserMobile: '' });
    setOtp(Array(6).fill(""));
    setReset("");
    setMobileError('');
    setSuccessOtp(false);
    setPasswordData({ NewPassword: '', ConfirmPassword: '' });
    setPasswordError('');
  };

  const handleClickForgetBack = () => {
    setIsReset(false);
    // Reset all forgot password related states
    setSaveData({ UserMobile: '' });
    setOtp(Array(6).fill(""));
    setReset("");
    setMobileError('');
    setSuccessOtp(false);
    setPasswordData({ NewPassword: '', ConfirmPassword: '' });
    setPasswordError('');
  };

  const handleGenerateOtp = async () => {
    if (!saveData.UserMobile) {
      setMobileError('Mobile number is required');
      return;
    }
    if (saveData.UserMobile.length !== 10) {
      setMobileError('Please enter a valid 10-digit mobile number');
      return;
    }

    const data = {
      phone: saveData.UserMobile,
    };

    setOtpLoading(true);
    try {
      const response = await ResetUserPassWord(data);
      console.log(response, 'OTP Response');
      
      if (response.data && response.data.message) {
        toast.success("OTP sent to your mobile number");
        setReset(response.data.message);
        setMobileError('');
        // Reset OTP inputs when new OTP is generated
        setOtp(Array(6).fill(""));
      } else {
        toast.error("User not found");
      }
    } catch (error) {
      console.error('Error generating OTP:', error);
      toast.error("User not found");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleChangeMobile = (event) => {
    const { name, value } = event.target;

    if (name === 'UserMobile') {
      // Remove any non-digit characters
      const numericValue = value.replace(/\D/g, '');
      
      if (numericValue.length > 10) {
        setMobileError('Mobile number cannot exceed 10 digits.');
      } else if (numericValue.length < 10 && numericValue !== '') {
        setMobileError('Mobile number must be 10 digits.');
      } else {
        setMobileError('');
      }

      setSaveData((prevData) => ({
        ...prevData,
        [name]: numericValue.slice(0, 10),
      }));
    }
  };

  const handleInputOtp = (e, index) => {
    const { value } = e.target;
    
    if (/^\d*$/.test(value)) { // Ensure only digits are allowed
      const newOtp = [...otp];
      newOtp[index] = value.slice(-1);
      const formattedOtp = newOtp.join('');

      setOtp(formattedOtp);
      
      console.log('OTP Array:', formattedOtp);
      
      // Move to next input if a digit is entered
      if (value && index < 5) {
        const nextInput = e.target.parentElement.children[index + 1];
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  };

  const handleKeyDown = (e, index) => {
    // Handle backspace to move to previous input
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      const prevInput = e.target.parentElement.children[index - 1];
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      toast.error('Please enter complete 6-digit OTP');
      return;
    }

    try {
      const data = {
        otp: otp
      }
      const response = await VerifyUserOtp(data);
      if (response.data.success === true) {
        toast.success('OTP verified successfully');
        setSuccessOtp(response.data.success);
      } else {
        toast.error("OTP Invalid");
      }
      
      console.log('Verifying OTP:', response);
      
    } catch (error) {
      console.error('Error verifying OTP:', error);
      toast.error('Invalid OTP. Please try again.');
    }
  };

  // New password reset handler
  const handleResetPassword = async () => {
    if (passwordData.NewPassword !== passwordData.ConfirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    }
    
    if (passwordData.NewPassword.length < 6) {
      setPasswordError('Password must be at least 6 characters long');
      return;
    }
    
    setResetPasswordLoading(true);
    try {
      // Add your password reset API call here
      const data = {
        phone: saveData.UserMobile,
        newPassword: passwordData.NewPassword
      };
      
      const response= await UpdateUserPassWord(data)
      console.log(response,'yyyyyyyyyyyy');
      if(response.status==201){
      setTimeout(() => {
        toast.success('Password reset successfully');
        setResetPasswordLoading(false);
        handleClickForgetBack(); // Go back to login
      }, 2000);
    }else{
      toast.error('something went worng')
    }
      console.log('Resetting password...', data);
      
    } catch (error) {
      console.error('Error resetting password:', error);
      setPasswordError('Failed to reset password. Please try again.');
      setResetPasswordLoading(false);
    }
  };

  return (
    <div className="b">
      <div className="min-h-screen bg-gradient-to-r from-blue-800 to-blue-900 flex">
        {/* Left Column: Login Form */}
        <div className="w-full lg:w-2/3 flex justify-center items-center px-6 py-12">
          <div className="w-full max-w-md bg-white shadow-xl rounded-lg p-8">
            <div className="flex flex-col items-center mb-6">
              <h3 className="text-2xl font-bold text-center text-black mb-4">
                {companyDetails.Name}
              </h3>
            </div>
            
            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
              {!isReset ? (
                <>
                  <div className="form-group">
                    <input
                      type="text"
                      id="email"
                      name="UserName"
                      required
                      placeholder="Username"
                      value={formData.UserName || ""}
                      onChange={handleChange}
                      className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
                    />
                  </div>
                  <div className="form-group relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="Password"
                      required
                      placeholder="Password"
                      value={formData.Password || ""}
                      onChange={handleChange}
                      className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
                    />
                    <div
                      className="password-toggle absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                      onClick={togglePasswordVisibility}
                    >
                      <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 btn btn-primary dark:active:bg-brand-200"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Log In"}
                  </button>
                  <p 
                    onClick={handleClickForget}
                    className="text-sm text-blue-600 hover:text-blue-800 hover:underline cursor-pointer text-center"
                  >
                    Forgot password?
                  </p>
                </>
              ) : (
                <>
                  {successOtp === false ? (
                    <>
                      <div className="form-group flex flex-col gap-2">
                        <label htmlFor="UserMobile">
                          Enter your registered Mobile Number to get OTP <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                          type="text"
                          id="UserMobile"
                          name="UserMobile"
                          placeholder="Enter Mobile No"
                          value={saveData.UserMobile || ''}
                          onChange={handleChangeMobile}
                          className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
                          required
                        />
                        {mobileError && <p className="text-red-500 text-sm">{mobileError}</p>}
                      </div>
                      
                      <button 
                        onClick={handleGenerateOtp} 
                        type="button" 
                        className="btn btn-primary"
                        disabled={otpLoading || !saveData.UserMobile || saveData.UserMobile.length !== 10}
                      >
                        {otpLoading ? "Sending..." : "Generate OTP"}
                      </button>
                      
                      {reset !== "" && (
                        <div className="flex flex-col gap-4">
                          <label className="text-sm font-medium">Enter 6-digit OTP</label>
                          <div className="flex space-x-2 justify-center items-center">
                            {Array(6)
                              .fill("")
                              .map((_, index) => (
                                <input
                                  key={index}
                                  type="text"
                                  value={otp[index] || ""}
                                  maxLength="1"
                                  className="w-12 h-12 text-center text-xl border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                  onChange={(e) => handleInputOtp(e, index)}
                                  onKeyDown={(e) => handleKeyDown(e, index)}
                                />
                              ))}
                          </div>
                          <button 
                            type="button"
                            onClick={handleVerifyOtp}
                            className="linear w-full rounded-xl bg-green-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-green-600 active:bg-green-700"
                          >
                            Verify OTP
                          </button>
                        </div>
                      )}
                      
                      <button
                        type="button"
                        onClick={handleClickForgetBack}
                        className="text-sm text-blue-600 hover:text-blue-800 hover:underline focus:outline-none text-center"
                      >
                        Back to Login
                      </button>
                    </>
                  ) : (
                    <>
                      {/* Create New Password Section */}
                      <div className="flex flex-col gap-4">
                        <h3 className="text-lg font-medium text-center mb-2">Create New Password</h3>
                        
                        <div className="form-group relative">
                          <input
                            type={showNewPassword ? "text" : "password"}
                            id="newPassword"
                            name="NewPassword"
                            required
                            placeholder="New Password"
                            value={passwordData.NewPassword || ""}
                            onChange={handlePasswordChange}
                            className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
                          />
                          <div
                            className="password-toggle absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                            onClick={toggleNewPasswordVisibility}
                          >
                            <i className={`fas ${showNewPassword ? "fa-eye-slash" : "fa-eye"}`} />
                          </div>
                        </div>
                        
                        <div className="form-group relative">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            id="confirmPassword"
                            name="ConfirmPassword"
                            required
                            placeholder="Confirm Password"
                            value={passwordData.ConfirmPassword || ""}
                            onChange={handlePasswordChange}
                            className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
                          />
                          <div
                            className="password-toggle absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                            onClick={toggleConfirmPasswordVisibility}
                          >
                            <i className={`fas ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`} />
                          </div>
                        </div>
                        
                        {passwordError && <p className="text-red-500 text-sm">{passwordError}</p>}
                        
                        <button
                          type="button"
                          onClick={handleResetPassword}
                          className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 btn btn-primary dark:active:bg-brand-200"
                          disabled={resetPasswordLoading || !passwordData.NewPassword || !passwordData.ConfirmPassword}
                        >
                          {resetPasswordLoading ? "Updating..." : "Reset Password"}
                        </button>
                        
                        <button
                          type="button"
                          onClick={handleClickForgetBack}
                          className="text-sm text-blue-600 hover:text-blue-800 hover:underline focus:outline-none text-center"
                        >
                          Back to Login
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
            </form>
          </div>
        </div>

        {/* Right Column: Image */}
        <div
          className="w-full lg:w-1/3 hidden lg:flex justify-end items-end bg-cover bg-center"
          style={{
            backgroundImage: `url(${auth_bg})`,
            borderBottomLeftRadius: "20%",
          }}
        ></div>
      </div>
    </div>
  );
}